// // src/Pages/ProductMaster.jsx
// import { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Box, Grid, Paper, Typography, TextField, Checkbox, FormControlLabel, Button, Divider, Tooltip, IconButton } from '@mui/material';
// import { Dialog, DialogTitle, DialogContent } from '@mui/material';
// import UnitMaster from './UnitMaster';
// import HSNMaster from './HsnMaster';
// import TaxMaster from './TaxMaster';
// import ProductGroupMaster from './ProGroupMaster';
// import Dropdown from '../components/Dropdown';
// import { Snackbar, Alert } from '@mui/material';
// import { ReactSortable } from 'react-sortablejs';
// import CloseIcon from '@mui/icons-material/Close';
// import ProductGroupSelect from '../components/ProductGroupSelect';
// import { FaFileExcel } from 'react-icons/fa';
// import { useAuth } from '../context/AuthContext';

// const transformUnits = data => (Array.isArray(data) ? data.map(i => ({ Id: i.unitId, value: i.unit })) : []);
// const transformHSNs = data => (Array.isArray(data) ? data.map(i => ({ Id: i.HSNId, value: i.HSNNo })) : []);
// const transformGSTs = data => (Array.isArray(data) ? data.map(i => ({ Id: i.TaxID, value: i.Taxcode })) : []);
// const transformConv = data => (Array.isArray(data) ? data.map(i => ({ Id: i.unitId, value: i.unit })) : []);

// export default function ProductMaster({ mode, onPopupCancel, connectionString }) {
//     const { user, selectedCompany, loading } = useAuth();
//     const API_BASE = `${connectionString}/api`;
//     const { id } = useParams();
//     const navigate = useNavigate();

//     // Basic fields
//     const [itemGroups, setItemGroups] = useState([]);
//     const [isLoadingGroups, setIsLoadingGroups] = useState(false); // New loading state
//     const [selectedItemId, setSelectedItemId] = useState('');
//     const [selectedItemValue, setSelectedItemValue] = useState('');
//     const [showInStock, setShowInStock] = useState(false);
//     const [applyBatchNo, setApplyBatchNo] = useState(false);
//     const [itemCode, setItemCode] = useState('');
//     const [description, setDescription] = useState('');
//     const [pkg, setPkg] = useState('');

//     // Dropdowns
//     const [units, setUnits] = useState([]);
//     const [unitId, setUnitId] = useState(100);
//     const [unitValue, setUnitValue] = useState('');

//     const [hsns, setHsns] = useState([]);
//     const [hsnId, setHsnId] = useState('');
//     const [hsnValue, setHsnValue] = useState('');

//     const [gsts, setGsts] = useState([]);
//     const [gstId, setGstId] = useState('');
//     const [gstValue, setGstValue] = useState('');

//     const [convUnits, setConvUnits] = useState([]);
//     const [convUnitId, setConvUnitId] = useState('');
//     const [convUnitValue, setConvUnitValue] = useState('');

//     // Inventory & pricing
//     const [opBal, setOpBal] = useState('');
//     const [saleRate, setSaleRate] = useState('');
//     const [saleDisc, setSaleDisc] = useState(0);
//     const [purchaseRate, setPurchaseRate] = useState('');
//     const [purchaseDisc, setPurchaseDisc] = useState(0);
//     const [convQty, setConvQty] = useState('');
//     const [minLevel, setMinLevel] = useState('');
//     const [maxLevel, setMaxLevel] = useState('');
//     const [minOrderQty, setMinOrderQty] = useState('');
//     const [selfLife, setSelfLife] = useState('');

//     // Popups
//     const [openUnitPopup, setOpenUnitPopup] = useState(false);
//     const [openHSNPopup, setOpenHSNPopup] = useState(false);
//     const [openGSTPopup, setOpenGSTPopup] = useState(false);
//     const [openGroupPopup, setOpenGroupPopup] = useState(false);
//     const [openConvPopup, setOpenConvPopup] = useState(false);

//     // Images
//     const [imageFiles, setImageFiles] = useState([]);
//     const [imagePreviews, setImagePreviews] = useState([]);
//     // --- NEW: zoomImage state (already present in your snippet, kept here)
//     const [zoomImage, setZoomImage] = useState(null);

//     // Meta
//     const [formError, setFormError] = useState('');
//     const companyId = selectedCompany?.CompId || null;
//     const fYear = getCurrentFYear();
//     const userId = user?.UserId || null;

//     const [serverImageIds, setServerImageIds] = useState([]);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     // Load lookups
//     useEffect(() => {
//         (async () => {
//             try {
//                 setIsLoadingGroups(true);
//                 await Promise.all([Hlp_Fn_Unit(), Hlp_Fn_Hsn(), Hlp_Fn_GST(), Hlp_Fn_ConvUnit(), Hlp_Fn_PrdGrp()]);
//             } catch (e) {
//                 console.error('Lookup load failed', e);
//             } finally {
//                 setIsLoadingGroups(false);
//             }
//         })();
//     }, []);

//     const Hlp_Fn_Unit = async () => {
//         try {
//             const { data } = await axios.get(`${API_BASE}/product-get-data/api/unit?companyId=${companyId}`);
//             setUnits(transformUnits(data));
//         } catch (e) {
//             console.error('Unit lookup failed', e);
//             setUnits([]);
//         }
//     };

//     const Hlp_Fn_Hsn = async () => {
//         try {
//             const { data } = await axios.get(`${API_BASE}/product-get-data/api/hsn?companyId=${companyId}`);
//             setHsns(transformHSNs(data));
//         } catch (e) {
//             console.error('HSN lookup failed', e);
//             setHsns([]);
//         }
//     };

//     const Hlp_Fn_GST = async () => {
//         try {
//             const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
//             setGsts(transformGSTs(data));
//         } catch (e) {
//             console.error('GST lookup failed', e);
//             setGsts([]);
//         }
//     };

//     const Hlp_Fn_ConvUnit = async () => {
//         try {
//             const { data } = await axios.get(`${API_BASE}/product-get-data/api/conv-unit?companyId=${companyId}`);
//             setConvUnits(transformConv(data));
//         } catch (e) {
//             console.error('Conversion-unit lookup failed', e);
//             setConvUnits([]);
//         }
//     };

//     const Hlp_Fn_PrdGrp = async () => {
//         try {
//             setIsLoadingGroups(true);
//             const { data } = await axios.get(`${API_BASE}/product-get-data/api/item-group?companyId=${companyId}`);
//             console.log(data);
//             setItemGroups(Array.isArray(data) ? data : []);
//         } catch (e) {
//             console.error('Product-group lookup failed', e);
//             setItemGroups([]);
//         } finally {
//             setIsLoadingGroups(false);
//         }
//     };

//     // If editing, fetch detail
//     useEffect(() => {
//         if (mode === 'edit' && id) {
//             (async () => {
//                 try {
//                     const cleanNumericInput = val => { return val === '0.00' || val === '0' || val === 0 || val === null || val === '' ? '' : String(val); };
//                     const { data } = await axios.get(`${API_BASE}/product/getDetails/${id}`);
//                     const itemGrpId = String(data.ItemGrpID || '');
//                     setSelectedItemId(itemGrpId);
//                     // Defer setting selectedItemValue until itemGroups is loaded
//                     setShowInStock(Boolean(data.inStock));
//                     setApplyBatchNo(Boolean(data.applyBatch));
//                     setItemCode(data.itemCode || '');
//                     setDescription(data.description || '');
//                     setUnitId(data.UnitId || '');
//                     setHsnId(data.HsnId || '');
//                     setGstId(data.GstId || '');
//                     setPkg(data.Pkg || '');
//                     setConvUnitId(data.ConvUnit || '');
//                     setOpBal(cleanNumericInput(data.OpStock));
//                     setSaleRate(cleanNumericInput(data.saleRate));
//                     setSaleDisc(cleanNumericInput(data.SaleDisc));
//                     setPurchaseRate(cleanNumericInput(data.purchaseRate));
//                     setPurchaseDisc(cleanNumericInput(data.PurcDisc));
//                     setConvQty(cleanNumericInput(data.ConvQty));
//                     setMinLevel(cleanNumericInput(data.MinLevel));
//                     setMaxLevel(cleanNumericInput(data.MaxLevel));
//                     setMinOrderQty(cleanNumericInput(data.MinOrderQty));
//                     setSelfLife(cleanNumericInput(data.SelfLife));

//                     const imgRes = await axios.get(`${API_BASE}/product/fetch-images?prodCode=${id}`);
//                     console.log(imgRes.data)
//                     const previews = imgRes.data.map(img => ({
//                         url: `data:${img.mimeType};base64,${img.image}`,
//                         name: img.fileName,
//                         id: img.id,
//                         sequence: img.sequence,
//                         isNew: false
//                     }));

//                     console.log(previews);

//                     setImagePreviews(previews);
//                     setServerImageIds(previews.map(p => p.id));
//                 } catch (e) {
//                     console.error('Detail load failed', e);
//                 }
//             })();
//         }
//     }, [mode, id]);

//     // Update selectedItemValue when itemGroups changes
//     useEffect(() => {
//         if (selectedItemId) {
//             const selectedGroup = itemGroups.find(g => String(g.ProdGRPID) === String(selectedItemId));
//             setSelectedItemValue(selectedGroup?.GroupName || '');
//         } else {
//             setSelectedItemValue('');
//         }
//     }, [itemGroups, selectedItemId]);

//     const handleSubmit = async e => {
//         e.preventDefault();
//         setFormError('');
//         if (!itemCode || !unitId || !hsnId || !gstId || !selectedItemId) {
//             setFormError('Please fill out all required fields');
//             return;
//         }

//         const groupObj = itemGroups.find(g => String(g.ProdGRPID) === String(selectedItemId));
//         const payload = { GroupId: selectedItemId ? selectedItemId : '', itemGroup: groupObj?.GroupName || '', inStock: showInStock ? 1 : 0, applyBatch: applyBatchNo ? 1 : 0, itemCode, description, unitId, unit: unitValue, pkg, hsnId, gstId, convUnit: convUnitId ? convUnitId : 0, convUnitVal: convUnitValue ? convUnitValue : null, optionalBalance: opBal ? opBal : 0, saleRate: saleRate ? saleRate : 0, saleDiscount: saleDisc ? saleDisc : 0, purchaseRate: purchaseRate ? purchaseRate : 0, purchaseDiscount: purchaseDisc ? purchaseDisc : 0, convQty: convQty ? convQty : 0, minLevel: minLevel ? minLevel : 0, maxLevel: maxLevel ? maxLevel : 0, minOrderQty: minOrderQty ? minOrderQty : 0, selfLife: selfLife ? selfLife : 0, companyId, fYear, userId, addUserId: userId };
//         try {
//             if (mode === 'add') {
//                 const res = await axios.post(`${API_BASE}/product/Insert`, payload);
//                 const insertId = res.data?.insertId;

//                 if (insertId && imageFiles.length > 0) {
//                     const formData = new FormData();
//                     formData.append('productCode', insertId);

//                     imageFiles.forEach((file, index) => {
//                         formData.append('images', file);
//                         formData.append('sequences', index + 1);
//                     });

//                     try {
//                         await axios.post(`${API_BASE}/product/uploadImages`, formData, {
//                             headers: { 'Content-Type': 'multipart/form-data' },
//                         });
//                     } catch (imgErr) {
//                         console.error('Image upload failed:', imgErr);
//                         setSnackbar({ open: true, message: 'Product saved but image upload failed.', severity: 'warning' });
//                     }
//                 }

//                 setSnackbar({ open: true, message: 'Product added successfully!', severity: 'success' });
//                 setTimeout(() => {
//                     if (typeof onPopupCancel === 'function') {
//                         onPopupCancel();
//                     } else {
//                         navigate(-1);
//                     }
//                 }, 200);
//             } else {
//                 await axios.put(`${API_BASE}/product/Update/${id}`, payload);

//                 const currentIds = imagePreviews.filter(p => p.id && !p.isNew).map(p => p.id);
//                 const deletedIds = serverImageIds.filter(id => !currentIds.includes(id));
//                 const newImages = imagePreviews.filter(p => p.isNew);
//                 const reordered = imagePreviews.filter(p => p.id && typeof p.sequence === 'number');

//                 if (newImages.length > 0 || deletedIds.length > 0 || reordered.length > 0) {
//                     const imageUpdateForm = new FormData();
//                     imageUpdateForm.append('productCode', id);

//                     imagePreviews.forEach((img, idx) => {
//                         const sequence = idx + 1;

//                         if (img.isNew) {
//                             const matchingFile = imageFiles[img.fileIndex];
//                             if (matchingFile) {
//                                 imageUpdateForm.append('images', matchingFile);
//                                 imageUpdateForm.append('sequences', sequence);
//                             }
//                         }
//                     });

//                     imageUpdateForm.append('deleteImageIds', JSON.stringify(deletedIds));
//                     imageUpdateForm.append('updateSequences', JSON.stringify(imagePreviews.map((p, idx) => ({ ...p, sequence: idx + 1 })).filter(p => p.id && !p.isNew).map(p => ({ id: p.id, sequence: p.sequence }))));

//                     try {
//                         await axios.put(`${API_BASE}/product/updateImages`, imageUpdateForm, { headers: { 'Content-Type': 'multipart/form-data' } });
//                     } catch (imgErr) {
//                         console.error('Image update failed:', imgErr);
//                         setSnackbar({ open: true, message: 'Product updated, but image update failed.', severity: 'warning' });
//                     }
//                 }
//                 setSnackbar({ open: true, message: 'Product updated successfully!', severity: 'success' });
//                 setTimeout(() => navigate(-1), 200);
//             }
//         } catch (error) {
//             console.error(error);
//             if (error.response?.status === 400) {
//                 const backendMsg = error.response.data?.message || 'Item code already exists.';
//                 setFormError(backendMsg);
//                 return;
//             }
//             setSnackbar({ open: true, message: 'Failed to save product. Please try again.', severity: 'error' });
//         }
//     };

//     return (
//         <Paper elevation={5} sx={{ p: 3, maxWidth: 1200, mx: 'auto', my: 2 }}>

//             <Box sx={{ position: 'relative', width: '100%', mb: 1.5 }}>
//                 <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, mt: -1.5, mb: 0.6 }}>
//                     {mode === 'add' ? 'Add New product' : 'Edit Product'}
//                 </Typography>
//                 {/* <Tooltip title="Bulk Import Products">
//                     <IconButton onClick={() => navigate("/main/insertProduct")} sx={{position: 'absolute', top: 0, right: 0, width: 40, height: 40, bgcolor: 'success.main', color: 'white', '&:hover': { bgcolor: 'success.dark' }, boxShadow: 3, zIndex: 10 }} >
//                         <FaFileExcel />
//                     </IconButton>
//                 </Tooltip> */}
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <Box display="flex" flexWrap="nowrap" gap={3}>
//                 {/* Product Details */}
//                 <Box flex="1 1 40%" minWidth={300}>
//                     <FormControlLabel control={<Checkbox checked={showInStock} onChange={e => setShowInStock(e.target.checked)} />} label="Show In Stock" sx={{mt: 1.5, mb: 1}} />
//                     <FormControlLabel control={<Checkbox checked={applyBatchNo} onChange={e => setApplyBatchNo(e.target.checked)} />} label="Apply Batch No" sx={{mt: 1.5, mb: 1}} />

//                     <Box mb={1.5}>
//                         <ProductGroupSelect
//                             itemGroups={itemGroups}
//                             value={selectedItemId}
//                             placeholder="— Select product group —"
//                             loading={isLoadingGroups}
//                             disabled={false}
//                             onAddNew={() => setOpenGroupPopup(true)}
//                             onChange={(selectedId, selectedName) => {
//                                 console.log('Selected ID:', selectedId, 'Selected Name:', selectedName);
//                                 setSelectedItemId(selectedId ?? '');
//                                 setSelectedItemValue(selectedName ?? '');
//                             }}
//                         />
//                     </Box>

//                     {/* Product Group dialog */}
//                     <Dialog open={openGroupPopup} maxWidth="sm" fullWidth onClose={() => {
//                         setOpenGroupPopup(false);
//                         Hlp_Fn_PrdGrp();
//                     }}>
//                         <DialogTitle>Add New Product Group</DialogTitle>
//                         <DialogContent>
//                             <ProductGroupMaster mode="add" connectionString={connectionString}
//                                 onPopupCancel={() => {
//                                     setOpenGroupPopup(false);
//                                     Hlp_Fn_PrdGrp();
//                                 }}
//                             />
//                         </DialogContent>
//                     </Dialog>

//                     <TextField fullWidth label="Item Code" size="small" required value={itemCode} onChange={e => setItemCode(e.target.value)} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }} />
//                     <TextField fullWidth label="Description" size="small" required value={description} onChange={e => setDescription(e.target.value)} multiline minRows={1}
//                         sx={{
//                             mb: 1.5,
//                             '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 },
//                             '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' },
//                         }}
//                     />

//                     <Box display="flex" gap={1} mb={1.5}>
//                         <Box flex={1}>
//                             <Dropdown id="unit" label="Unit" valueKey="Id" labelKey="value" value={unitId} options={[...units, { Id: '__add__', value: '+ Add New Unit' }]} required={true} fullWidth
//                                 onChange={(opt) => {
//                                     if (opt.Id === '__add__') {
//                                         setOpenUnitPopup(true);
//                                     } else {
//                                         setUnitId(opt.Id);
//                                         setUnitValue(opt.value);
//                                     }
//                                 }}
//                             />
//                         </Box>
//                         <Box flex={1}>
//                             <Dropdown id="hsn" label="HSN" valueKey="Id" labelKey="value" value={hsnId} options={[...hsns, { Id: '__add__', value: '+ Add New HSN' }]} required={true} fullWidth
//                                 onChange={(opt) => {
//                                     if (opt.Id === '__add__') {
//                                         setOpenHSNPopup(true);
//                                     } else {
//                                         setHsnId(opt.Id);
//                                         setHsnValue(opt.value);
//                                     }
//                                 }}
//                             />
//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={1} mb={1.5}>
//                         <Box flex={1}>
//                             <Dropdown id="gst" label="GST" valueKey="Id" labelKey="value" value={gstId} options={[...gsts, { Id: '__add__', value: '+ Add New GST' }]} required={true} fullWidth
//                                 onChange={(opt) => {
//                                     if (opt.Id === '__add__') {
//                                         setOpenGSTPopup(true);
//                                     } else {
//                                         setGstId(opt.Id);
//                                         setGstValue(opt.value);
//                                     }
//                                 }}
//                             />
//                         </Box>
//                         <Box flex={1}>
//                             <TextField fullWidth label="Opening Balance" type="text" value={opBal} size="small" sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                                 onChange={e => {
//                                     const val = e.target.value;
//                                     if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
//                                         setOpBal(val);
//                                     }
//                                 }}
//                             />
//                         </Box>
//                     </Box>
//                 </Box>

//                 <Box flex="1 1 30%" minWidth={300} sx={{ mt: 1.7 }}>
//                     <Box display="flex" gap={1}>
//                         <Box mb={1.5} flex={1}>
//                             <Dropdown id="convUnit" label="Conversion Unit" valueKey="Id" labelKey="value" value={convUnitId} options={[...convUnits, { Id: '__add__', value: '+ Add New Conversion Unit' }]}
//                                 onChange={opt => {
//                                     if (!opt) {
//                                         setConvUnitId(0);
//                                         setConvUnitValue('');
//                                     } else if (opt.Id === '__add__') {
//                                         setOpenConvPopup(true);
//                                     } else {
//                                         setConvUnitId(opt.Id);
//                                         setConvUnitValue(opt.value);
//                                     }
//                                 }}
//                             />
//                         </Box>
//                         <Box flex={1}>
//                             <TextField fullWidth label="Conversion Qty" size="small" type="text" value={convQty}
//                                 onChange={e => {
//                                     const val = e.target.value;
//                                     if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
//                                         setConvQty(val);
//                                     }
//                                 }}
//                                 sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             />
//                         </Box>
//                     </Box>
//                     <Box display="flex" gap={1}>
//                         <TextField fullWidth label="Pkg." size="small" type="text" value={pkg} sx={{ '& .MuiInputBase-root': { height: 38 } }}
//                             onChange={(e) => {
//                                 const val = e.target.value;
//                                 if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
//                                     setPkg(val);
//                                 }
//                             }}
//                         />
//                         <TextField fullWidth label="Self Life" size="small" type="text" value={selfLife} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             onChange={e => {
//                                 const val = e.target.value;
//                                 if (val === '' || /^\d+$/.test(val)) {
//                                     setSelfLife(val);
//                                 }
//                             }}
//                         />
//                     </Box>
//                     <Box display="flex" gap={1}>
//                         <TextField fullWidth label="Min Level" size="small" type="text" value={minLevel} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             onChange={e => {
//                                 const val = e.target.value;
//                                 if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
//                                     setMinLevel(val);
//                                 }
//                             }}
//                         />
//                         <TextField fullWidth label="Max Level" size="small" type="text" value={maxLevel} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             onChange={e => {
//                                 const val = e.target.value;
//                                 if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
//                                     setMaxLevel(val);
//                                 }
//                             }}
//                         />
//                     </Box>
//                     <Box display="flex" gap={1} width="49.3%">
//                         <TextField fullWidth label="MOQ" size="small" type="text" value={minOrderQty} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             onChange={e => {
//                                 const val = e.target.value;
//                                 if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
//                                     setMinOrderQty(val);
//                                 }
//                             }}
//                         />
//                     </Box>
//                     <Box display="flex" gap={1}>
//                         <TextField fullWidth label="Sale Rate" size="small" type="text" value={saleRate} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             onChange={e => {
//                                 const val = e.target.value;
//                                 if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
//                                     setSaleRate(val);
//                                 }
//                             }}
//                         />
//                         <TextField fullWidth label="Sale Discount (%)" size="small" type="text" value={saleDisc} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             onChange={e => {
//                                 const val = e.target.value;
//                                 if (val === '') {
//                                     setSaleDisc('');
//                                     return;
//                                 }
//                                 const regex = /^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/;
//                                 if (regex.test(val)) {
//                                     setSaleDisc(val);
//                                 }
//                             }}
//                         />
//                     </Box>
//                     <Box display="flex" gap={1}>
//                         <TextField fullWidth label="Purchase Rate" size="small" type="text" value={purchaseRate} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             onChange={e => {
//                                 const val = e.target.value;
//                                 if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
//                                     setPurchaseRate(val);
//                                 }
//                             }}
//                         />
//                         <TextField fullWidth label="Purchase Discount (%)" size="small" type="text" value={purchaseDisc} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
//                             onChange={e => {
//                                 const val = e.target.value;
//                                 if (val === '') {
//                                     setPurchaseDisc('');
//                                     return;
//                                 }
//                                 const regex = /^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/;
//                                 if (regex.test(val)) {
//                                     setPurchaseDisc(val);
//                                 }
//                             }}
//                         />
//                     </Box>
//                 </Box>
//                 <Box flex="1 1 30%" minWidth={300}>
//                     <Typography variant="subtitle2" gutterBottom>Product Images</Typography>
//                     <Button variant="outlined" component="label">
//                         Upload Images
//                         <input type="file" accept="image/*" multiple hidden
//                             onChange={(e) => {
//                                 const files = Array.from(e.target.files);
//                                 const newPreviews = files.map((file, idx) => ({
//                                     url: URL.createObjectURL(file),
//                                     name: file.name,
//                                     isNew: true,
//                                     fileIndex: imageFiles.length + idx
//                                 }));
//                                 setImageFiles(prev => [...prev, ...files]);
//                                 setImagePreviews(prev => [...prev, ...newPreviews]);
//                             }}
//                         />
//                     </Button>

//                     <ReactSortable list={imagePreviews} animation={200} className="image-sortable-container" style={{ display: 'flex', flexWrap: 'wrap', marginTop: '16px' }}
//                         setList={(newState) => {
//                             // NOTE: preserve relationship between imageFiles and imagePreviews when reordering
//                             // Build newFiles array by mapping newState entries which may have fileIndex
//                             const newFiles = newState.map(p => (p.fileIndex !== undefined ? imageFiles[p.fileIndex] : undefined)).filter(Boolean);
//                             const updatedPreviews = newState.map((p, idx) => ({ ...p, fileIndex: (p.isNew ? idx : p.fileIndex) }));
//                             setImageFiles(newFiles);
//                             setImagePreviews(updatedPreviews);
//                         }}
//                     >
//                         {imagePreviews.map((img, idx) => (
//                             // --- NEW: Make the image container clickable to open zoom dialog
//                             // Comment: this is where zoom logic is wired to each image preview.
//                             <Box
//                                 key={idx}
//                                 onClick={() => setZoomImage(img.url)} // --- NEW: open zoom with this image
//                                 sx={{
//                                     position: 'relative',
//                                     width: 100,
//                                     height: 100,
//                                     borderRadius: 1,
//                                     overflow: 'hidden',
//                                     border: '1px solid #ccc',
//                                     mx: 1,
//                                     my: 1,
//                                     display: 'inline-block',
//                                     '&:hover .remove-btn': { opacity: 1 },
//                                     cursor: 'move' // keep draggable cursor for sortable
//                                 }}
//                             >
//                                 <img src={img.url} alt={`img-${idx}`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
//                                 <Box
//                                     className="remove-btn"
//                                     sx={{
//                                         position: 'absolute',
//                                         top: 0,
//                                         left: 0,
//                                         width: '100%',
//                                         height: '100%',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         bgcolor: 'rgba(0, 0, 0, 0.3)',
//                                         opacity: 0,
//                                         transition: 'opacity 0.2s ease-in-out'
//                                     }}
//                                 >
//                                     <CloseIcon fontSize="medium"
//                                         sx={{ cursor: 'pointer', color: 'white', backgroundColor: 'rgba(0,0,0,0.6)', borderRadius: '50%', padding: 0.5 }}
//                                         onClick={(e) => {
//                                             // Prevent click from bubbling to parent which would open zoom modal
//                                             e.stopPropagation();
//                                             const updatedFiles = [...imageFiles];
//                                             const updatedPreviews = [...imagePreviews];
//                                             updatedFiles.splice(idx, 1);
//                                             updatedPreviews.splice(idx, 1);
//                                             setImageFiles(updatedFiles);
//                                             setImagePreviews(updatedPreviews);
//                                         }}
//                                     />
//                                 </Box>
//                                 <Typography variant="caption" display="block" align="center" sx={{ position: 'absolute', bottom: 0, width: '100%', bgcolor: 'rgba(0,0,0,0.5)', color: '#fff' }} >
//                                     #{idx + 1}
//                                 </Typography>
//                             </Box>
//                         ))}
//                     </ReactSortable>
//                 </Box>
//             </Box>

//             {/* --- NEW: Zoom dialog for images */}
//             <Dialog open={!!zoomImage} onClose={() => setZoomImage(null)} maxWidth="md" fullWidth
//                 PaperProps={{ sx: { height: '90vh', maxHeight: '90vh' } }} // --- NEW: increase dialog height
//             >
//                 <Box
//                     sx={{
//                         position: 'relative', p: 2, bgcolor: 'black', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden',
//                         height: '100%',              // --- NEW: make inner box fill dialog height
//                     }}
//                 >
//                     {zoomImage && (
//                         <img src={zoomImage} alt="Zoomed"
//                             style={{
//                                 maxWidth: '100%',
//                                 // --- NEW: reserve space for padding / close icon; keep image within 90vh
//                                 maxHeight: 'calc(90vh - 48px)',
//                                 cursor: 'zoom-in',
//                                 transition: 'transform 0.2s ease'
//                             }}
//                             onClick={(e) => {
//                                 // Toggle zoom-in / zoom-out by setting transform style inline
//                                 e.stopPropagation();
//                                 const el = e.target;
//                                 if (!el.style.transform || el.style.transform === '') {
//                                     el.style.transform = 'scale(2)';
//                                     el.style.cursor = 'zoom-out';
//                                 } else {
//                                     el.style.transform = '';
//                                     el.style.cursor = 'zoom-in';
//                                 }
//                             }}
//                         />
//                     )}
//                     <CloseIcon sx={{ position: 'absolute', top: 8, right: 8, color: 'white', cursor: 'pointer', zIndex: 10 }} onClick={() => setZoomImage(null)} />
//                 </Box>
//             </Dialog>
//             {/* --- END NEW: Zoom dialog */}

//             <Dialog open={openUnitPopup} maxWidth="sm" fullWidth
//                 onClose={() => {
//                     setOpenUnitPopup(false);
//                     Hlp_Fn_Unit();
//                 }}
//             >
//                 <DialogContent>
//                     <UnitMaster mode="add" connectionString={connectionString}
//                         onPopupCancel={() => {
//                             setOpenUnitPopup(false);
//                             Hlp_Fn_Unit();
//                         }}
//                     />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openHSNPopup} maxWidth="sm" fullWidth
//                 onClose={() => {
//                     setOpenHSNPopup(false);
//                     Hlp_Fn_Hsn();
//                 }}
//             >
//                 <DialogContent>
//                     <HSNMaster mode="add" connectionString={connectionString}
//                         onPopupCancel={() => {
//                             setOpenHSNPopup(false);
//                             Hlp_Fn_Hsn();
//                         }}
//                     />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openGSTPopup} maxWidth="sm" fullWidth
//                 onClose={() => {
//                     setOpenGSTPopup(false);
//                     Hlp_Fn_GST();
//                 }}
//             >
//                 <DialogContent>
//                     <TaxMaster mode="add" connectionString={connectionString}
//                         onPopupCancel={() => {
//                             setOpenGSTPopup(false);
//                             Hlp_Fn_GST();
//                         }}
//                     />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openConvPopup} maxWidth="sm" fullWidth
//                 onClose={() => {
//                     setOpenConvPopup(false);
//                     Hlp_Fn_ConvUnit();
//                 }}
//             >
//                 <DialogContent>
//                     <UnitMaster mode="add" connectionString={connectionString}
//                         onPopupCancel={() => {
//                             setOpenConvPopup(false);
//                             Hlp_Fn_ConvUnit();
//                         }}
//                     />
//                 </DialogContent>
//             </Dialog>

//             {formError && (<Typography color="error" align="center" sx={{ mt: 2 }}> {formError} </Typography>)}

//             <Box mt={3} sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
//                 <Button variant="contained" onClick={handleSubmit} sx={{ width: 180 }}> {mode === 'add' ? 'Submit' : 'Update'} </Button>
//                 <Button variant="contained" onClick={onPopupCancel ?? (() => navigate(-1))} color="error" sx={{ width: 180 }}> Cancel </Button>
//             </Box>

//             <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
//                 <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Paper>
//     );
// }







// src/Pages/ProductMaster.jsx
import { colors as themeColors } from '../utils/theme';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Grid, Paper, Typography, TextField, Checkbox, FormControlLabel, Button, Divider, Tooltip, IconButton } from '@mui/material';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import UnitMaster from './UnitMaster';
import HSNMaster from './HsnMaster';
import TaxMaster from './TaxMaster';
import ProductGroupMaster from './ProGroupMaster';
import Dropdown from '../components/Dropdown';
import { Snackbar, Alert } from '@mui/material';
import { ReactSortable } from 'react-sortablejs';
import CloseIcon from '@mui/icons-material/Close';
import ProductGroupSelect from '../components/ProductGroupSelect';
import { FaFileExcel } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { useConfigure } from '../context/ConfigureContext';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { InputLabel } from '@mui/material';
import { getCurrentFYear } from '../utils/financialYear';

const transformUnits = data => (Array.isArray(data) ? data.map(i => ({ Id: i.unitId, value: i.unit })) : []);
const transformHSNs = data => (Array.isArray(data) ? data.map(i => ({ Id: i.HSNId, value: i.HSNNo })) : []);
const transformGSTs = data => (Array.isArray(data) ? data.map(i => ({ Id: i.TaxID, TaxID: i.TaxID, value: i.Taxcode, GST: i.GST })) : []);
const transformConv = data => (Array.isArray(data) ? data.map(i => ({ Id: i.unitId, value: i.unit })) : []);

export default function ProductMaster({ mode, onPopupCancel, connectionString }) {
    const { user, selectedCompany, loading } = useAuth();
    const API_BASE = `${connectionString}/api`;
    const { id } = useParams();
    const navigate = useNavigate();

    // Basic fields
    const [itemGroups, setItemGroups] = useState([]);
    const [isLoadingGroups, setIsLoadingGroups] = useState(false); // New loading state
    const [selectedItemId, setSelectedItemId] = useState('');
    const [selectedItemValue, setSelectedItemValue] = useState('');
    const [showInStock, setShowInStock] = useState(true);
    const [applyBatchNo, setApplyBatchNo] = useState(false);
    const [itemCode, setItemCode] = useState('');
    const [description, setDescription] = useState('');
    const [pkg, setPkg] = useState('');

    // Dropdowns
    const [units, setUnits] = useState([]);
    const [unitId, setUnitId] = useState(100);
    const [unitValue, setUnitValue] = useState('');

    const [hsns, setHsns] = useState([]);
    const [hsnId, setHsnId] = useState('');
    const [hsnValue, setHsnValue] = useState('');

    const [gsts, setGsts] = useState([]);
    const [gstId, setGstId] = useState('');
    const [gstValue, setGstValue] = useState('');

    const [convUnits, setConvUnits] = useState([]);
    const [convUnitId, setConvUnitId] = useState('');
    const [convUnitValue, setConvUnitValue] = useState('');

    const [cessValue, setCessValue] = useState("")

    // Inventory & pricing
    const [OpStock, setOpStock] = useState('');
    const [saleMRP, setSaleMRP] = useState('');
    const [saleRate, setSaleRate] = useState('');
    const [saleDisc, setSaleDisc] = useState(0);
    const [purchaseMRP, setPurchaseMRP] = useState('');
    const [purchaseRate, setPurchaseRate] = useState('');
    const [purchaseDisc, setPurchaseDisc] = useState(0);

    // Track which field was last manually entered (for GST recalculation)
    const [lastSaleField, setLastSaleField] = useState(null); // 'MRP' or 'Rate'
    const [lastPurchaseField, setLastPurchaseField] = useState(null); // 'MRP' or 'Rate'
    const [convQty, setConvQty] = useState('');
    const [minLevel, setMinLevel] = useState('');
    const [maxLevel, setMaxLevel] = useState('');
    const [minOrderQty, setMinOrderQty] = useState('');
    const [selfLife, setSelfLife] = useState('');
    const [valueRate, setValueRate] = useState('');

    // Popups
    const [openUnitPopup, setOpenUnitPopup] = useState(false);
    const [openHSNPopup, setOpenHSNPopup] = useState(false);
    const [openGSTPopup, setOpenGSTPopup] = useState(false);
    const [openGroupPopup, setOpenGroupPopup] = useState(false);
    const [openConvPopup, setOpenConvPopup] = useState(false);

    // Images
    const [imageFiles, setImageFiles] = useState([]);
    const [imagePreviews, setImagePreviews] = useState([]);
    // --- NEW: zoomImage state (already present in your snippet, kept here)
    const [zoomImage, setZoomImage] = useState(null);

    // Meta
    const [formError, setFormError] = useState('');
    const companyId = selectedCompany?.CompId || null;
    const AppRegID = selectedCompany?.AppRegID || null;
    const fYear = getCurrentFYear();
    const userId = user?.UserId || null;

    // Get configure settings
    const { isFeatureEnabled } = useConfigure();
    const applyMRPInSale = isFeatureEnabled('Apply MRP in Sale?');
    const applyMRPInPurchase = isFeatureEnabled('Apply MRP in Purchase?');

    const [serverImageIds, setServerImageIds] = useState([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const requiredAsteriskStyle = { '& .MuiFormLabel-asterisk': { color: 'red', }, };

    // snackbar states of all child components
    //    const [snackbarHSN, setSnackbarHSN] = useState({ open: false, message: '', severity: 'success' });

    // Load lookups
    useEffect(() => {
        (async () => {
            try {
                setIsLoadingGroups(true);
                await Promise.all([Hlp_Fn_Unit(), Hlp_Fn_Hsn(), Hlp_Fn_GST(), Hlp_Fn_ConvUnit(), Hlp_Fn_PrdGrp()]);
            } catch (e) {
                // console.error('Lookup load failed', e);
                setSnackbar({ open: true, message: 'Lookup load failed.', severity: 'error' });
            } finally {
                setIsLoadingGroups(false);
            }
        })();
    }, []);

    const Hlp_Fn_Unit = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/unit?companyId=${companyId}`);
            setUnits(transformUnits(data));
        } catch (e) {
            // console.error('Unit lookup failed', e);
            setSnackbar({ open: true, message: 'Unit lookup failed.', severity: 'error' });
            setUnits([]);
        }
    };

    const Hlp_Fn_Hsn = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/hsn?companyId=${companyId}`);
            setHsns(transformHSNs(data));
        } catch (e) {
            // console.error('HSN lookup failed', e);
            setSnackbar({ open: true, message: 'HSN lookup failed.', severity: 'error' });
            setHsns([]);
        }
    };

    const Hlp_Fn_GST = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
            setGsts(transformGSTs(data));
            console.log(data)
        } catch (e) {
            // console.error('GST lookup failed', e);
            setSnackbar({ open: true, message: 'GST lookup failed.', severity: 'error' });
            setGsts([]);
        }
    };

    const Hlp_Fn_ConvUnit = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/conv-unit?companyId=${companyId}`);
            setConvUnits(transformConv(data));
        } catch (e) {
            // console.error('Conversion-unit lookup failed', e);
            setSnackbar({ open: true, message: 'Conversion-unit lookup failed.', severity: 'error' });
            setConvUnits([]);
        }
    };

    const Hlp_Fn_PrdGrp = async () => {
        try {
            setIsLoadingGroups(true);
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/item-group?companyId=${companyId}`);
            console.log('hdhddhc dhc shd ch sd:', data);
            setItemGroups(Array.isArray(data) ? data : []);
        } catch (e) {
            // console.error('Product-group lookup failed', e);
            setSnackbar({ open: true, message: 'Product-group lookup failed.', severity: 'error' });
            setItemGroups([]);
        } finally {
            setIsLoadingGroups(false);
        }
    };

    // If editing, fetch detail
    useEffect(() => {
        if (mode === 'edit' && id) {
            (async () => {
                try {
                    const cleanNumericInput = val => { return val === '0.00' || val === '0' || val === 0 || val === null || val === '' ? '' : String(val); };
                    const { data } = await axios.get(`${API_BASE}/product/getDetails/${id}`);
                    const itemGrpId = String(data.ItemGrpID || '');
                    setSelectedItemId(itemGrpId);
                    // Defer setting selectedItemValue until itemGroups is loaded
                    setShowInStock(Boolean(data.inStock));
                    setApplyBatchNo(Boolean(data.applyBatch));
                    setItemCode(data.itemCode || '');
                    setDescription(data.description || '');
                    setUnitId(data.UnitId || '');
                    setHsnId(data.HsnId || '');
                    setGstId(data.GstId || '');
                    setPkg(data.Pkg || '');
                    setConvUnitId(data.ConvUnit || '');
                    setOpStock(cleanNumericInput(data.OpStock));
                    setSaleMRP(cleanNumericInput(data.SaleMRP));
                    setSaleRate(cleanNumericInput(data.saleRate));
                    setSaleDisc(cleanNumericInput(data.SaleDisc));
                    setPurchaseMRP(cleanNumericInput(data.PurchaseMRP));
                    setPurchaseRate(cleanNumericInput(data.purchaseRate));
                    setPurchaseDisc(cleanNumericInput(data.PurcDisc));
                    setConvQty(cleanNumericInput(data.ConvQty));
                    setMinLevel(cleanNumericInput(data.MinLevel));
                    setMaxLevel(cleanNumericInput(data.MaxLevel));
                    setMinOrderQty(cleanNumericInput(data.MinOrderQty));
                    setSelfLife(cleanNumericInput(data.SelfLife));
                    setCessValue(cleanNumericInput(data.cessValue));
                    setValueRate(cleanNumericInput(data.ValueRate));
                    const imgRes = await axios.get(`${API_BASE}/product/fetch-images?prodCode=${id}`);
                    console.log(imgRes.data)
                    const previews = imgRes.data.map(img => ({ url: `data:${img.mimeType};base64,${img.image}`, name: img.fileName, id: img.id, sequence: img.sequence, isNew: false }));

                    console.log(previews);

                    setImagePreviews(previews);
                    setServerImageIds(previews.map(p => p.id));
                } catch (e) {
                    // console.error('Detail load failed', e);
                    setSnackbar({ open: true, message: 'Detail load failed.', severity: 'error' });
                }
            })();
        }
    }, [mode, id]);

    // Update selectedItemValue when itemGroups changes
    useEffect(() => {
        if (selectedItemId) {
            const selectedGroup = itemGroups.find(g => String(g.ProdGRPID) === String(selectedItemId));
            setSelectedItemValue(selectedGroup?.GroupName || '');
        } else {
            setSelectedItemValue('');
            // In add mode, default to first non-primary item from the first primary group
            if (mode === 'add' && itemGroups.length > 0) {
                const primaryGroup = itemGroups.find(g => g.IsPrimary === 1);
                if (primaryGroup) {
                    const firstChild = itemGroups.find(g => g.IsPrimary !== 1 && String(g.UnderGRP) === String(primaryGroup.ProdGRPID));
                    if (firstChild) {
                        setSelectedItemId(String(firstChild.ProdGRPID));
                    }
                }
            }
        }
    }, [itemGroups, selectedItemId, mode]);

    useEffect(() => {
        if (mode === 'edit' && unitId && units.length > 0) {
            const u = units.find(x => String(x.Id) === String(unitId));
            if (u) {
                setUnitValue(u.value);
            }
        }
    }, [mode, unitId, units]);

    const handleSubmit = async e => {
        e.preventDefault();
        setFormError('');
        console.log("itemCode:" + itemCode, "description:" + description, "unitValue:" + unitId, "hsnId:" + hsnId, "gstId:" + gstId, "selectedItemId:" + selectedItemId, "OpStock:" + OpStock)
        if (!itemCode || !description || !unitId || !selectedItemId) {
            setFormError('Please fill out all required fields');
            console.log()
            return;
        }

        const groupObj = itemGroups.find(g => String(g.ProdGRPID) === String(selectedItemId));
        const payload = { GroupId: selectedItemId ? selectedItemId : '', itemGroup: groupObj?.GroupName || '', inStock: showInStock ? 1 : 0, applyBatch: applyBatchNo ? 1 : 0, itemCode, description, unitId, unit: unitValue, pkg, hsnId, gstId, convUnit: convUnitId ? convUnitId : 0, convUnitVal: convUnitValue ? convUnitValue : null, optionalBalance: OpStock ? OpStock : 0, saleMRP: saleMRP ? saleMRP : 0, saleRate: saleRate ? saleRate : 0, saleDiscount: saleDisc ? saleDisc : 0, purchaseMRP: purchaseMRP ? purchaseMRP : 0, purchaseRate: purchaseRate ? purchaseRate : 0, purchaseDiscount: purchaseDisc ? purchaseDisc : 0, convQty: convQty ? convQty : 0, minLevel: minLevel ? minLevel : 0, maxLevel: maxLevel ? maxLevel : 0, minOrderQty: minOrderQty ? minOrderQty : 0, selfLife: selfLife ? selfLife : 0, companyId, fYear, userId, addUserId: userId, cessValue: cessValue, valueRate: valueRate || '0.00', AppRegID };
        try {
            if (mode === 'add') {
                const res = await axios.post(`${API_BASE}/product/Insert`, payload);
                const insertId = res.data?.insertId;

                if (insertId && imageFiles.length > 0) {
                    const formData = new FormData();
                    formData.append('productCode', insertId);
                    formData.append('AppRegID', AppRegID);

                    imageFiles.forEach((file, index) => {
                        formData.append('images', file);
                        formData.append('sequences', index + 1);
                    });

                    try {
                        await axios.post(`${API_BASE}/product/uploadImages`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });
                    } catch (imgErr) {
                        // console.error('Image upload failed:', imgErr);
                        setSnackbar({ open: true, message: 'Product saved but image upload failed.', severity: 'warning' });
                    }
                }

                // POPUP MODE
                if (typeof onPopupCancel === "function") {
                    setSnackbar({ open: true, message: "Product added successfully!", severity: 'success' })
                    setTimeout(() => { onPopupCancel({ created: true }) }, 600)
                } else {
                    setSnackbar({ open: true, message: "Product added successfully!", severity: 'success' })
                    setTimeout(() => { navigate(-1); }, 600);
                }
                return;
            }
            else {
                await axios.put(`${API_BASE}/product/Update/${id}`, payload);

                const currentIds = imagePreviews.filter(p => p.id && !p.isNew).map(p => p.id);
                const deletedIds = serverImageIds.filter(id => !currentIds.includes(id));
                const newImages = imagePreviews.filter(p => p.isNew);
                const reordered = imagePreviews.filter(p => p.id && typeof p.sequence === 'number');

                if (newImages.length > 0 || deletedIds.length > 0 || reordered.length > 0) {
                    const imageUpdateForm = new FormData();
                    imageUpdateForm.append('productCode', id);

                    imagePreviews.forEach((img, idx) => {
                        const sequence = idx + 1;

                        if (img.isNew) {
                            const matchingFile = imageFiles[img.fileIndex];
                            if (matchingFile) {
                                imageUpdateForm.append('images', matchingFile);
                                imageUpdateForm.append('sequences', sequence);
                            }
                        }
                    });

                    imageUpdateForm.append('deleteImageIds', JSON.stringify(deletedIds));
                    imageUpdateForm.append('updateSequences', JSON.stringify(imagePreviews.map((p, idx) => ({ ...p, sequence: idx + 1 })).filter(p => p.id && !p.isNew).map(p => ({ id: p.id, sequence: p.sequence }))));

                    try {
                        await axios.put(`${API_BASE}/product/updateImages`, imageUpdateForm, { headers: { 'Content-Type': 'multipart/form-data' } });
                    } catch (imgErr) {
                        // console.error('Image update failed:', imgErr);
                        setSnackbar({ open: true, message: 'Product updated, but image update failed.', severity: 'warning' });
                    }
                }
                setSnackbar({ open: true, message: "Product updated successfully!", severity: 'success' })
                if (typeof onPopupCancel === "function") {
                    setTimeout(() => { onPopupCancel({ updated: true }) }, 600);
                } else {
                    setTimeout(() => { navigate(-1); }, 600);
                }
                return;
            }
        } catch (error) {
            console.error(error);
            if (error.response?.status === 400) {
                const backendMsg = error.response.data?.message || 'Item code already exists.';
                setFormError(backendMsg);
                return;
            }
            setSnackbar({ open: true, message: 'Failed to save product. Please try again.', severity: 'error' });
        }
    };

    const handleCancel = onPopupCancel ?? (() => navigate(-1));

    // ──────────────── Alt+S (Save/Update) & Alt+C (Cancel) shortcuts ────────────────
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey) return;

            if (e.code === "KeyS") {
                e.preventDefault();
                handleSubmit(e);
            } else if (e.code === "KeyC") {
                e.preventDefault();
                handleCancel();
            }
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    });

    useEffect(() => {
        if (gstId && gsts.length > 0) {
            const gstObj = gsts.find(g => String(g.TaxID) === String(gstId));
            if (gstObj) {
                const tax = Number(gstObj.GST) || 0;

                // SALE: Recalculate based on which field was last manually entered
                if (lastSaleField === 'MRP' && saleMRP && Number(saleMRP) > 0) {
                    const calculatedRate = Number(saleMRP) / (1 + tax / 100);
                    setSaleRate(calculatedRate.toFixed(2));
                } else if (lastSaleField === 'Rate' && saleRate && Number(saleRate) > 0) {
                    const calculatedMRP = Number(saleRate) * (1 + tax / 100);
                    setSaleMRP(calculatedMRP.toFixed(2));
                }

                // PURCHASE: Recalculate based on which field was last manually entered
                if (lastPurchaseField === 'MRP' && purchaseMRP && Number(purchaseMRP) > 0) {
                    const calculatedRate = Number(purchaseMRP) / (1 + tax / 100);
                    setPurchaseRate(calculatedRate.toFixed(2));
                } else if (lastPurchaseField === 'Rate' && purchaseRate && Number(purchaseRate) > 0) {
                    const calculatedMRP = Number(purchaseRate) * (1 + tax / 100);
                    setPurchaseMRP(calculatedMRP.toFixed(2));
                }
            }
        }
    }, [gstId, gsts, lastSaleField, lastPurchaseField, saleMRP, saleRate, purchaseMRP, purchaseRate]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", px: { xs: 1, sm: 2, md: 3 }, }} >
            <Paper elevation={3} sx={{ p: 3, maxWidth: 1200, width: "100%", my: { xs: 1, md: 2 }, mx: { xs: 0, sm: 3, md: "auto" }, boxShadow: { xs: onPopupCancel ? "none" : "none", sm: onPopupCancel ? "none" : "0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)" } }} >
                {/* <Box sx={{ position: 'relative', width: '100%', mb: { xs: 1, md: 1.5 } }}>
                    <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, fontWeight: 600, mt: { xs: 0, sm: -1.5 }, mb: { xs: 0.4, md: 0.6 } }}>
                        {mode === 'add' ? 'Add New product' : 'Edit Product'}
                    </Typography>
                    <Tooltip title="Bulk Import Products">
                        <IconButton onClick={() => navigate("/main/insertProduct")} sx={{ position: 'absolute', top: 0, right: 0, width: 40, height: 40, bgcolor: 'success.main', color: 'white', '&:hover': { bgcolor: 'success.dark' }, boxShadow: 3, zIndex: 10 }} >
                            <FaFileExcel />
                        </IconButton>
                    </Tooltip>
                </Box>

                <Divider sx={{ mb: { xs: 2, md: 3 } }} /> */}

                <Box sx={{ position: 'relative', width: '100%', mb: { xs: 1, md: 1.5 } }}>

                    {/* Back arrow — mobile/tablet only */}
                    <IconButton onClick={handleCancel} sx={{ position: 'absolute', top: 0, left: 0, display: { xs: 'flex', md: 'none' }, color: 'text.secondary', p: 0.5, }} >
                        <ArrowBackIcon fontSize="small" />
                    </IconButton>

                    <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, fontWeight: 600, mt: { xs: 0, sm: -1.5 }, mb: { xs: 0.4, md: 0.6 }, }} >
                        {mode === 'add' ? 'Add New Product' : 'Edit Product'}
                    </Typography>

                    <Box sx={{ position: 'absolute', top: 0, right: 0, zIndex: 10, display: 'flex', gap: 1 }}>
                        {/* Hidden in the popup: it would navigate away from the form that opened it */}
                        {!onPopupCancel && (
                            <Tooltip title="Bulk Import Products">
                                <IconButton onClick={() => navigate("/main/insertProduct")} sx={{ position: 'absolute', top: 0, right: 0, width: { xs: 30, sm: 34 }, height: { xs: 30, sm: 34 }, bgcolor: 'success.main', color: 'white', '&:hover': { bgcolor: 'success.dark' }, boxShadow: 3, zIndex: 10, }} >
                                    <FaFileExcel />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Box>
                </Box>

                <Divider sx={{ mb: { xs: 2, md: 1 }, mt: { xs: 1.5, md: 2 } }} />

                <Box display="flex" flexWrap={{ xs: 'wrap', md: 'nowrap' }} gap={{ xs: 2, md: 3 }} >
                    {/* Product Details */}
                    <Box flex={{ xs: '1 1 100%', md: '1 1 40%' }} minWidth={{ xs: '100%', md: 300 }}>
                        <FormControlLabel control={<Checkbox checked={showInStock} onChange={e => setShowInStock(e.target.checked)} />} label="Show In Stock" sx={{ mt: 1.5, mb: 1 }} />
                        <FormControlLabel control={<Checkbox checked={applyBatchNo} onChange={e => setApplyBatchNo(e.target.checked)} />} label="Apply Batch No" sx={{ mt: 1.5, mb: 1 }} />

                        <TextField fullWidth label="Item Code" size="small" required value={itemCode} onChange={e => setItemCode(e.target.value)} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }} />
                        <TextField fullWidth label="Description" size="small" required value={description} onChange={e => setDescription(e.target.value)} InputLabelProps={{ sx: requiredAsteriskStyle }} inputProps={{ maxLength: 500 }} multiline minRows={1} sx={{ mb: 1.5, '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '8px 12px', minHeight: '80px' }, }} helperText={`${description.length}/500 characters`} />

                        <Box display="flex" gap={{ xs: 0.5, sm: 1 }} mb={1.5} flexDirection={{ xs: 'column', sm: 'row' }}>
                            <Box flex={1}>
                                <Dropdown id="unit" label="Unit" valueKey="Id" labelKey="value" value={unitId} options={[...units, { Id: '__add__', value: '+ Add New Unit' }]} required={true} fullWidth
                                    onChange={(opt) => {
                                        if (opt.Id === '__add__') {
                                            setOpenUnitPopup(true);
                                        } else {
                                            setUnitId(opt.Id);
                                            setUnitValue(opt.value);
                                        }
                                    }}

                                />
                            </Box>
                            <Box flex={1}>
                                <Dropdown id="hsn" label="HSN" valueKey="Id" labelKey="value" value={hsnId} options={[...hsns, { Id: '__add__', value: '+ Add New HSN' }]} fullWidth
                                    onChange={(opt) => {
                                        if (opt.Id === '__add__') {
                                            setOpenHSNPopup(true);
                                        } else {
                                            setHsnId(opt.Id);
                                            setHsnValue(opt.value);
                                        }
                                    }}
                                />
                            </Box>
                        </Box>

                        <Box display="flex" gap={{ xs: 0.5, sm: 1 }} mb={1.5} flexDirection={{ xs: 'column', sm: 'row' }}>
                            <Box flex={1}>
                                <Dropdown id="gst" label="GST" valueKey="Id" labelKey="value" value={gstId} options={[...gsts, { Id: '__add__', value: '+ Add New GST' }]} fullWidth required={false}
                                    onChange={(opt) => {
                                        if (opt.Id === '__add__') {
                                            setOpenGSTPopup(true);
                                        } else {
                                            setGstId(opt.Id);
                                            setGstValue(opt.value);
                                        }
                                    }}
                                />
                            </Box>
                            <Box flex={1}>
                                <TextField
                                    fullWidth
                                    label="Op. Bal"
                                    type="text"
                                    value={OpStock}
                                    size="small"
                                    sx={{ '& .MuiInputBase-root': { height: 38 } }}
                                    onChange={e => {
                                        const val = e.target.value;
                                        if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                            setOpStock(val);
                                        }
                                    }}
                                />
                            </Box>
                            <Box flex={1}>
                                <TextField
                                    fullWidth
                                    label="Value Rate"
                                    type="text"
                                    value={valueRate}
                                    size="small"
                                    sx={{ '& .MuiInputBase-root': { height: 38 } }}
                                    onChange={e => {
                                        const val = e.target.value;
                                        if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                            setValueRate(val);
                                        }
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Total Valuation (readonly, shown only if valueRate > 0) */}
                        {valueRate && Number(valueRate) > 0 && (
                            <Box mb={1.5}>
                                <TextField
                                    fullWidth
                                    label="Total Valuation"
                                    type="text"
                                    value={(Number(OpStock || 0) * Number(valueRate || 0)).toFixed(2)}
                                    size="small"
                                    InputProps={{ readOnly: true }}
                                    sx={{
                                        '& .MuiInputBase-root': { height: 38 },
                                        '& .MuiInputBase-input': {
                                            backgroundColor: themeColors.neutral.surfaceMuted,
                                            cursor: 'not-allowed'
                                        }
                                    }}
                                />
                            </Box>
                        )}

                        <Box mb={1.5}>
                            <ProductGroupSelect required={false} itemGroups={itemGroups} value={selectedItemId} placeholder="— Select product group —" loading={isLoadingGroups} disabled={false} onAddNew={() => setOpenGroupPopup(true)}
                                onChange={(selectedId, selectedName) => {
                                    console.log('Selected ID:', selectedId, 'Selected Name:', selectedName);
                                    setSelectedItemId(selectedId ?? '');
                                    setSelectedItemValue(selectedName ?? '');
                                }}
                            />
                        </Box>

                        {/* Product Group dialog */}
                        <Dialog open={openGroupPopup} maxWidth="sm" fullWidth onClose={(e, reason) => {
                            if (reason === 'backdropClick') return;
                            setOpenUnitPopup(false);
                            Hlp_Fn_Unit();
                        }}>
                            <DialogContent>
                                <ProductGroupMaster mode="add" connectionString={connectionString}
                                    onPopupCancel={() => {
                                        setOpenGroupPopup(false);
                                        Hlp_Fn_PrdGrp();
                                    }}
                                />
                            </DialogContent>
                        </Dialog>
                    </Box>

                    <Box flex={{ xs: '1 1 100%', md: '1 1 30%' }} minWidth={{ xs: '100%', md: 300 }} sx={{ mt: { xs: 0, md: 1.7 } }}>
                        <Box display="flex" gap={{ xs: 0.5, sm: 1 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                            <Box mb={1.5} flex={1}>
                                <Dropdown id="convUnit" label="Conversion Unit" valueKey="Id" labelKey="value" value={convUnitId} options={[...convUnits, { Id: '__add__', value: '+ Add New Conversion Unit' }]}
                                    onChange={opt => {
                                        if (!opt) {
                                            setConvUnitId(0);
                                            setConvUnitValue('');
                                        } else if (opt.Id === '__add__') {
                                            setOpenConvPopup(true);
                                        } else {
                                            setConvUnitId(opt.Id);
                                            setConvUnitValue(opt.value);
                                        }
                                    }}
                                />
                            </Box>
                            <Box flex={1}>
                                <TextField fullWidth label="Conversion Qty" size="small" type="text" value={convQty} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                    onChange={e => {
                                        const val = e.target.value;
                                        if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                            setConvQty(val);
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box display="flex" gap={{ xs: 0.5, sm: 1 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                            <TextField fullWidth label="Pkg." size="small" type="text" value={pkg} sx={{ '& .MuiInputBase-root': { height: 38 } }}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                        setPkg(val);
                                    }
                                }}
                            />
                            <TextField fullWidth label="Self Life" size="small" type="text" value={selfLife} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d+$/.test(val)) {
                                        setSelfLife(val);
                                    }
                                }}
                            />
                        </Box>
                        <Box display="flex" gap={{ xs: 0.5, sm: 1 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                            <TextField fullWidth label="Min Level" size="small" type="text" value={minLevel} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                        setMinLevel(val);
                                    }
                                }}
                            />
                            <TextField fullWidth label="Max Level" size="small" type="text" value={maxLevel} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                        setMaxLevel(val);
                                    }
                                }}
                            />
                        </Box>
                        <Box display="flex" gap={{ xs: 0.5, sm: 1 }} flexDirection={{ xs: 'column', sm: 'row' }}>

                            <TextField fullWidth label="MOQ" size="small" type="text" value={minOrderQty} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                        setMinOrderQty(val);
                                    }
                                }}
                            />

                            <TextField fullWidth label="Cess per unit" size="small" type="number" value={cessValue} sx={{ '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    setCessValue(val);
                                }}
                            />

                        </Box>

                        <Box display="flex" gap={{ xs: 0.5, sm: 1 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                            <TextField label="Sale MRP" size="small" type="text" value={saleMRP} sx={{ flex: 1, '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                        setSaleMRP(val);
                                        setLastSaleField('MRP');
                                        if (val === '') {
                                            setSaleRate('');
                                        } else if (Number(val) > 0) {
                                            const gstObj = gsts.find(g => String(g.TaxID) === String(gstId));
                                            const tax = Number(gstObj?.GST) || 0;
                                            const calculatedRate = Number(val) / (1 + tax / 100);
                                            setSaleRate(calculatedRate.toFixed(2));
                                        }
                                    }
                                }}
                            />
                            <TextField label="Sale Rate" size="small" type="text" value={saleRate} sx={{ flex: 1, '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                        setSaleRate(val);
                                        setLastSaleField('Rate');
                                        if (val === '') {
                                            setSaleMRP('');
                                        } else if (Number(val) > 0) {
                                            const gstObj = gsts.find(g => String(g.TaxID) === String(gstId));
                                            const tax = Number(gstObj?.GST) || 0;
                                            const calculatedMRP = Number(val) * (1 + tax / 100);
                                            setSaleMRP(calculatedMRP.toFixed(2));
                                        }
                                    }
                                }}
                            />
                            <TextField fullWidth label="Sale Discount (%)" size="small" type="text" value={saleDisc} sx={{ flex: 1, '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '') {
                                        setSaleDisc('');
                                        return;
                                    }
                                    const regex = /^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/;
                                    if (regex.test(val)) {
                                        setSaleDisc(val);
                                    }
                                }}
                            />
                        </Box>

                        <Box display="flex" gap={{ xs: 0.5, sm: 1 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                            <TextField label="Purchase MRP" size="small" type="text" value={purchaseMRP} sx={{ flex: 1, minWidth: '120px', '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                        setPurchaseMRP(val);
                                        setLastPurchaseField('MRP');
                                        if (val === '') {
                                            setPurchaseRate('');
                                        } else if (Number(val) > 0) {
                                            const gstObj = gsts.find(g => String(g.TaxID) === String(gstId));
                                            const tax = Number(gstObj?.GST) || 0;
                                            const calculatedRate = Number(val) / (1 + tax / 100);
                                            setPurchaseRate(calculatedRate.toFixed(2));
                                        }
                                    }
                                }}
                            />
                            <TextField label="Purchase Rate" size="small" type="text" value={purchaseRate} sx={{ flex: 1, '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '' || /^\d*\.?\d{0,2}$/.test(val)) {
                                        setPurchaseRate(val);
                                        setLastPurchaseField('Rate');
                                        if (val === '') {
                                            setPurchaseMRP('');
                                        } else if (Number(val) > 0) {
                                            const gstObj = gsts.find(g => String(g.TaxID) === String(gstId));
                                            const tax = Number(gstObj?.GST) || 0;
                                            const calculatedMRP = Number(val) * (1 + tax / 100);
                                            setPurchaseMRP(calculatedMRP.toFixed(2));
                                        }
                                    }
                                }}
                            />
                            <TextField label="Purchase Discount (%)" size="small" type="text" value={purchaseDisc} sx={{ flex: 1, minWidth: '120px', '& .MuiInputBase-root': { height: 38, mb: 1.5 } }}
                                onChange={e => {
                                    const val = e.target.value;
                                    if (val === '') {
                                        setPurchaseDisc('');
                                        return;
                                    }
                                    const regex = /^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/;
                                    if (regex.test(val)) {
                                        setPurchaseDisc(val);
                                    }
                                }}
                            />
                        </Box>
                    </Box>

                    {/* ❌ COMMENTED: Upload Images section */}
                    {/* <Box flex={{ xs: '1 1 100%', md: '1 1 30%' }} minWidth={{ xs: '100%', md: 200 }}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontSize: { xs: '0.85rem', md: '0.875rem' } }}>Product Images</Typography>
                        <Button variant="outlined" component="label" fullWidth sx={{ mb: 2 }}>
                            Upload Images
                            <input type="file" accept="image/*" multiple hidden
                                onChange={(e) => {
                                    const files = Array.from(e.target.files);
                                    const newPreviews = files.map((file, idx) => ({ url: URL.createObjectURL(file), name: file.name, isNew: true, fileIndex: imageFiles.length + idx }));
                                    setImageFiles(prev => [...prev, ...files]);
                                    setImagePreviews(prev => [...prev, ...newPreviews]);
                                }}
                            />
                        </Button>

                        <ReactSortable list={imagePreviews} animation={200} className="image-sortable-container" style={{ display: 'flex', flexWrap: 'wrap', marginTop: '16px', justifyContent: 'flex-start' }}
                            setList={(newState) => {
                                // NOTE: preserve relationship between imageFiles and imagePreviews when reordering
                                // Build newFiles array by mapping newState entries which may have fileIndex
                                const newFiles = newState.map(p => (p.fileIndex !== undefined ? imageFiles[p.fileIndex] : undefined)).filter(Boolean);
                                const updatedPreviews = newState.map((p, idx) => ({ ...p, fileIndex: (p.isNew ? idx : p.fileIndex) }));
                                setImageFiles(newFiles);
                                setImagePreviews(updatedPreviews);
                            }}
                        >
                            {imagePreviews.map((img, idx) => (
                                // --- NEW: Make the image container clickable to open zoom dialog
                                // Comment: this is where zoom logic is wired to each image preview.
                                <Box key={idx} onClick={() => setZoomImage(img.url)} sx={{ position: 'relative', width: { xs: 80, sm: 90, md: 100 }, height: { xs: 80, sm: 90, md: 100 }, borderRadius: 1, overflow: 'hidden', border: '1px solid #ccc', mx: { xs: 0.5, sm: 0.75, md: 1 }, my: { xs: 0.5, sm: 0.75, md: 1 }, display: 'inline-block', '&:hover .remove-btn': { opacity: 1 }, cursor: 'move' }} >
                                    <img src={img.url} alt={`img-${idx}`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                    <Box className="remove-btn" sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(0, 0, 0, 0.3)', opacity: 0, transition: 'opacity 0.2s ease-in-out' }} >
                                        <CloseIcon fontSize="medium" sx={{ cursor: 'pointer', color: 'white', backgroundColor: 'rgba(0,0,0,0.6)', borderRadius: '50%', padding: 0.5 }}
                                            onClick={(e) => {
                                                // Prevent click from bubbling to parent which would open zoom modal
                                                e.stopPropagation();
                                                const updatedFiles = [...imageFiles];
                                                const updatedPreviews = [...imagePreviews];
                                                updatedFiles.splice(idx, 1);
                                                updatedPreviews.splice(idx, 1);
                                                setImageFiles(updatedFiles);
                                                setImagePreviews(updatedPreviews);
                                            }}
                                        />
                                    </Box>
                                    <Typography variant="caption" display="block" align="center" sx={{ position: 'absolute', bottom: 0, width: '100%', bgcolor: 'rgba(0,0,0,0.5)', color: '#fff', fontSize: { xs: '0.65rem', sm: '0.75rem' } }} >
                                        #{idx + 1}
                                    </Typography>
                                </Box>
                            ))}
                        </ReactSortable>
                    </Box> */}
                </Box>

                {/* --- NEW: Zoom dialog for images */}
                <Dialog open={!!zoomImage} onClose={() => setZoomImage(null)} maxWidth="md" fullWidth PaperProps={{ sx: { height: { xs: '80vh', sm: '85vh', md: '90vh' }, maxHeight: { xs: '80vh', sm: '85vh', md: '90vh' } } }} >
                    <Box sx={{ position: 'relative', p: { xs: 1, sm: 1.5, md: 2 }, bgcolor: 'black', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', height: '100%', }} >
                        {zoomImage && (
                            <img src={zoomImage} alt="Zoomed" style={{ maxWidth: '100%', maxHeight: 'calc(90vh - 48px)', cursor: 'zoom-in', transition: 'transform 0.2s ease' }}
                                onClick={(e) => {
                                    // Toggle zoom-in / zoom-out by setting transform style inline
                                    e.stopPropagation();
                                    const el = e.target;
                                    if (!el.style.transform || el.style.transform === '') {
                                        el.style.transform = 'scale(2)';
                                        el.style.cursor = 'zoom-out';
                                    } else {
                                        el.style.transform = '';
                                        el.style.cursor = 'zoom-in';
                                    }
                                }}
                            />
                        )}
                        <CloseIcon sx={{ position: 'absolute', top: { xs: 4, md: 8 }, right: { xs: 4, md: 8 }, color: 'white', cursor: 'pointer', zIndex: 10, fontSize: { xs: 24, md: 32 } }} onClick={() => setZoomImage(null)} />
                    </Box>
                </Dialog>
                {/* --- END NEW: Zoom dialog */}

                <Dialog open={openUnitPopup} maxWidth="sm" fullWidth
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick') return; // ❌ block outside click
                        setOpenUnitPopup(false);               // ✅ allow Submit / Cancel
                        Hlp_Fn_Unit();
                    }}
                >
                    <DialogContent>
                        <UnitMaster mode="add" connectionString={connectionString} units={units}
                            onPopupCancel={() => {
                                setOpenUnitPopup(false);
                                Hlp_Fn_Unit();
                            }}
                        />
                    </DialogContent>
                </Dialog>
                <Dialog open={openHSNPopup} maxWidth="sm" fullWidth
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick') return;
                        setOpenHSNPopup(false);
                        Hlp_Fn_Hsn();
                    }}
                >
                    <DialogContent>
                        <HSNMaster mode="add" connectionString={connectionString}
                            onPopupCancel={() => {
                                setOpenHSNPopup(false);
                                Hlp_Fn_Hsn();
                            }}
                        />
                    </DialogContent>
                </Dialog>
                <Dialog open={openGSTPopup} maxWidth="sm" fullWidth
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick') return;
                        setOpenGSTPopup(false);
                        Hlp_Fn_GST();
                    }}
                >
                    <DialogContent>
                        <TaxMaster mode="add" connectionString={connectionString}
                            onPopupCancel={() => {
                                setOpenGSTPopup(false);
                                Hlp_Fn_GST();
                            }}
                        />
                    </DialogContent>
                </Dialog>
                <Dialog open={openConvPopup} maxWidth="sm" fullWidth
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick') return;
                        setOpenConvPopup(false);
                        Hlp_Fn_ConvUnit();
                    }}
                >
                    <DialogContent>
                        <UnitMaster mode="add" connectionString={connectionString}
                            onPopupCancel={() => {
                                setOpenConvPopup(false);
                                Hlp_Fn_ConvUnit();
                            }}
                        />
                    </DialogContent>
                </Dialog>

                {formError && (<Typography color="error" align="center" sx={{ mt: 2, fontSize: { xs: '0.875rem', md: '1rem' } }}> {formError} </Typography>)}

                <Box mt={3} sx={{ display: 'flex', justifyContent: 'center', gap: { xs: 1.5, sm: 2, md: 3 }, flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
                    <Button variant="contained" onClick={handleSubmit} sx={{ width: { xs: '100%', sm: 180 }, fontSize: { xs: '0.875rem', sm: '1rem' } }}> {mode === 'add' ? 'Submit' : 'Update'} </Button>
                    <Button variant="contained" onClick={handleCancel} color="error" sx={{ width: { xs: '100%', sm: 180 }, fontSize: { xs: '0.875rem', sm: '1rem' } }}> Cancel </Button>
                </Box>

                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
                    <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant="filled">
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </Paper>
        </Box>
    );
}